// @ts-ignore react-native-web has Picker
import { Picker } from 'react-native'
export default Picker
